import { render, staticRenderFns } from "./LicenzaScaduta.vue?vue&type=template&id=5b8953da&scoped=true&"
import script from "./LicenzaScaduta.vue?vue&type=script&lang=js&"
export * from "./LicenzaScaduta.vue?vue&type=script&lang=js&"
import style0 from "./LicenzaScaduta.vue?vue&type=style&index=0&id=5b8953da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8953da",
  null
  
)

export default component.exports